import { GamesLandingPage } from '../componentsF/GamesLandingPageAI.jsx'

const IndexPage = () => {
  return <GamesLandingPage />
}

export default IndexPage
